import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalEditFormTrimmedEmail, optionalEditFormTrimmedString, } from '../zod-helpers/index.js';
import { CONTACT_CONSTRAINTS } from './constraints.js';
import { CONTACT_PREFERRED_METHODS } from './preferred-method/index.js';
// Edit: blank maps to null so Prisma explicitly clears the column; undefined skips the column.
const preferredMethodEditFormSchema = z
    .enum([...CONTACT_PREFERRED_METHODS, ''], 'Invalid preferred contact method.')
    .optional()
    .nullable()
    .transform((value) => (value === '' ? null : value));
export const contactEditFormSchema = z.object({
    contactName: z
        .string()
        .trim()
        .min(1, `${capitalize(CONTACT_CONSTRAINTS.contactName.label.toLowerCase())} is required.`)
        .max(CONTACT_CONSTRAINTS.contactName.maxLength)
        .optional(),
    title: optionalEditFormTrimmedString(CONTACT_CONSTRAINTS.title.maxLength),
    email: optionalEditFormTrimmedEmail(CONTACT_CONSTRAINTS.email.maxLength, `Invalid ${CONTACT_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: optionalEditFormTrimmedString(CONTACT_CONSTRAINTS.phone.maxLength),
    preference: preferredMethodEditFormSchema,
    defaultFlag: z.boolean().optional().nullable(),
});
//# sourceMappingURL=update-form.js.map